import { Button, Paper } from "@mui/material";
import { DataGrid } from '@mui/x-data-grid';
import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import axios from "../../config/authaxios";
import Dropdown from "../../css/dropdown.module.scss";
import { useStyles } from '../../theme/theme';


const style = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: 400,
  bgcolor: "background.paper",
  border: "2px solid #000",
  boxShadow: 24,
  p: 4,
};


function Coupon() {

  const navigate = useNavigate();

  const [coupons, setCoupons] = useState([]);
  const [page, setPage] = useState(0);
  const [limit, setLimit] = useState(10);
  const [isUsed, setIsUsed] = useState(false);
  const [isMore, setIsMore] = useState(false);
  const [nodata, setNodata] = useState(false);
  const [open, setOpen] = useState(false);
  const [price, setPrice] = useState();
  const [expiry, setExpiry] = useState(null);
  const classes = useStyles();
  const [pageSize, setPageSize] = useState(25);

  const CouponsColomns = [
    {
      field: 's_no',
      headerName: 'S. No.',
      headerClassName: 'super-app-theme--header',
      flex: 1,
      filterable: false,
      renderCell: (index) => index.api?.getRowIndexRelativeToVisibleRows(index.row._id) + 1,
    },
    {
      field: '_id',
      headerName: 'ID',
      headerClassName: 'super-app-theme--header',
      flex: 1,
      minWidth: 200,
    },
    {
      field: 'code',
      headerName: 'Code',
      headerClassName: 'super-app-theme--header',
      flex: 1,
      minWidth: 200,
    },
    {
      field: 'pin',
      headerName: 'Pin',
      headerClassName: 'super-app-theme--header',
      flex: 1,
      minWidth: 200,
    },
    {
      field: 'price',
      headerName: 'Price',
      headerClassName: 'super-app-theme--header',
      flex: 1,
      minWidth: 200,
    },
    {
      field: 'type',
      headerName: 'Type',
      headerClassName: 'super-app-theme--header',
      flex: 1,
      minWidth: 200,
    },
    {
      field: 'is_used',
      headerName: 'Used',
      headerClassName: 'super-app-theme--header',
      flex: 1,
      minWidth: 200,
    },
    {
      field: 'is_deleted',
      headerName: 'Deleted',
      headerClassName: 'super-app-theme--header',
      flex: 1,
      minWidth: 200,
    },
    {
      field: 'expiry',
      headerName: 'Expiry',
      headerClassName: 'super-app-theme--header',
      flex: 1,
      minWidth: 200,
    },
    {
      field: 'created_at',
      headerName: 'Created At',
      headerClassName: 'super-app-theme--header',
      flex: 1,
      minWidth: 200,
    },
    {
      field: 'order_at',
      headerName: 'Ordered At',
      headerClassName: 'super-app-theme--header',
      flex: 1,
      minWidth: 200,
    },
  ]


  const fetchCoupon = () => {
    setPage(0);
    setNodata(true);
    setIsMore(false);
    let temp = "?";

    temp += "page=" + 0 + "&";

    temp += "used=" + isUsed + "&";

    // if (isDeleted && isDeleted !== "") {
    // 	temp += "isDeleted=" + isDeleted + "&";
    // }
    if (limit) {
      temp += "limit=" + limit + "&";
    }
    if (price) {

      temp += "price=" + price + "&";
    }
    //console.log("temkp-->", temp);
    axios.get(`/admin/coupons-list${temp}`).then((res) => {
      //console.log(res.data.response);
      let data = res.data.response;
      if (res.data.status) {
        setCoupons(res.data.response);
        // setLoad(false)
        if (data && data.length < limit) {
          setIsMore(true);
        }
        if (data.length === 0) {
          setNodata(true);
        } else {
          setNodata(false);
        }
        setPage(1);
      }
    });
  };

  useEffect(() => {
    fetchCoupon();
    return () => {
      setCoupons([]);
      setPrice()
    };
  }, [isUsed, limit, price]);

  const Showmore = () => {
    setNodata(true);
    setIsMore(false);
    let temp = "?";

    if (page === 0 || page) {
      temp += "page=" + page + "&";
    }

    if (limit) {
      temp += "limit=" + limit + "&";
    }
    temp += "used=" + isUsed + "&";
    temp += "price=" + price + "&";

    //console.log("-->temp-->", temp);
    axios.get(`/admin/coupons-list${temp}`).then((res) => {
      let data = res.data.response;
      //console.log("-->", data);
      //console.log("length-->", Object.keys(data).length);
      if (Object.keys(data).length === 0) {
        setNodata(false);
        setIsMore(true);
      }
      let temp = [...coupons, ...data];

      if (data.length < limit) {
        setIsMore(true);
      }
      setCoupons(temp);
      setNodata(false);
      setPage(page + 1);
      // //console.log(res.data);
    });
  };

  return (
    <>
      {/* <section className={CardStyle.main}> */}
      <section

      >
        <section>
          <section style={{ width: "45%" }}>
            <div className={Dropdown.dropdown}>
              {coupons.length > 0 && !isMore && (
                <Button variant="contained" sx={{ ml: 1, my: 2 }} color='info' className={Dropdown.dropbtn} onClick={Showmore}>
                  More
                </Button>
              )}
            </div>
            <div className={Dropdown.dropdown}>
              <Button variant="contained" sx={{ ml: 1, my: 2 }} color='info' className={Dropdown.dropbtn}>Price</Button>
              <div className={Dropdown.dropdown_content}>
                <a disabled={price === 10 ? true : false} onClick={() => { setPrice(10); }}>10</a>
                <a disabled={price === 20 ? true : false} onClick={() => { setPrice(20); }}>20</a>
                <a disabled={price === 30 ? true : false} onClick={() => { setPrice(30); }}>30</a>
                <a disabled={price === 50 ? true : false} onClick={() => { setPrice(50); }}>50</a>
              </div>
            </div>
            <div className={Dropdown.dropdown}>
              <Button variant="contained" sx={{ ml: 1, my: 2 }} color='info' className={Dropdown.dropbtn}>limit</Button>
              <div className={Dropdown.dropdown_content}>
                <a className={limit === 25 ? "disabled" : "notDisabled"} onClick={() => { setLimit(25); setPage(0); }}>25</a>
                <a disabled={limit === 50 ? true : false} onClick={() => { setLimit(50); setPage(0); }}>50</a>
                <a disabled={limit === 100 ? true : false} onClick={() => { setLimit(100); setPage(0); }}>100</a>
                <a disabled={limit === 500 ? true : false} onClick={() => { setLimit(500); setPage(0); }}>500</a>
                <a disabled={limit === 1000 ? true : false} onClick={() => { setLimit(1000); setPage(0); }}>1000</a>
              </div>
            </div>

            <div className={Dropdown.dropdown}>
              <Button variant="contained" sx={{ ml: 1, my: 2 }} color='info' className={Dropdown.dropbtn}>Used</Button>
              <div className={Dropdown.dropdown_content}>
                <a onClick={() => { setIsUsed(true); }}>True</a>
                <a onClick={() => { setIsUsed(false); }}>False</a>
              </div>
            </div>
          </section>
        </section>
        {nodata && !coupons.length == 0 && <section>Loading...</section>}

        <Paper sx={{
          bgcolor: '#fff',
          '& .super-app-theme--header': {
            bgcolor: '#DC8449',
            color: '#fff',
          },
        }} elevation={0}>

          {console.log("coupons-->", coupons)}
          <DataGrid
            className={classes.root}
            sx={{
              border: 0,
            }}
            hideFooterPagination
            // getRowHeight={() => 'auto'}
            autoHeight
            rows={coupons}
            columns={CouponsColomns}
            getRowId={(row) => row._id}
            disableSelectionOnClick
            disableRowSelectionOnClick
            experimentalFeatures={{ newEditingApi: true }}
            // pagination
            pageSize={pageSize}
            disableColumnSelector
          />
        </Paper>

      </section>

      {
        coupons.length > 0 && !isMore && (
          <Button variant="contained" sx={{ ml: 1, my: 2 }} color='info' onClick={Showmore}>
            More
          </Button>
        )
      }
      {/* </section> */}
    </>
  );
}

export default Coupon;

